import * as yup from 'yup';

const validationSchema = yup.object({
  vehicleId: yup
    .mixed()
    .test(
      'required',
      'Required',
      (option) => option != null && Boolean(option.value)
    ),
});

export default validationSchema;
